import { scan } from "react-scan";

import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import {
  RouterProvider,
} from 'react-router-dom';

import './styles/index.css';

import './i18n';

import { TooltipProvider } from './components/ui/tooltip.tsx';
import { ModalProvider } from './providers/ModalProvider.tsx';
import Layout from './components/layout/Layout.tsx';
import { router } from './routes.tsx';

if (import.meta.hot) {
  scan();
}

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.replayIntegration(),
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Layout>
      <ModalProvider>
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      </ModalProvider>
    </Layout>
  </React.StrictMode>
);
